"use client";
import { Link } from "react-router-dom";
import { useState } from "react";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon, ChevronDownIcon } from "@heroicons/react/24/outline";

const navigation = [

  // { name: "About", href: "/about" },
  { 
    name: " ETPL Services", 
 href: "/services" 
  },
  { 
    name: "PMWANI", 
    href: "/pm-wani" 
  },
  { 
    name: "Projects", 
    subMenu: [
      { name: "ETPL Kendra", href: "/projects/etpl-kendra" },
      { name: "CSP Points", href: "/csp-point" },
      { name: "ATM", href: "/atm" },
    ]
  },
  { 
    name: "Franchisees", 
    subMenu: [
      { name: "Why ETPL Kendras?", href: "/franchisees/why-etpl" },
      { name: "Apply for ETPL Kendras", href: "/franchisees/apply" },
      { name: "District Franchisee", href: "/franchisees/district" },
      { name: "Pincode Franchisee", href: "/franchisees/pincode" },
    ]
  },
  { name: "Careers", href: "/careers" },
  { name: "Contact Us", href: "/contact-us" },
];

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);

  return (
    <header className="bg-white shadow-md fixed w-full z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center py-4">
        <Link to="/" className="-m-1.5 p-1.5" >
          <span className="sr-only">ETL</span>
          <img src="/logo/logo.jpeg" alt="Logo"
            className="h-16 lg:h-18 w-auto"
          />
        </Link>        
        
        <div className="hidden lg:flex items-center space-x-3">
          {navigation.map((item) => (
            <div key={item.name} className="relative group">
              {item.subMenu ? (
                <>
                  <button 
                    className="text-gray-700 hover:text-[#5C4033] flex items-center gap-1 focus:outline-none px-3 py-0"
                    onMouseEnter={() => setActiveMenu(item.name)}
                    onMouseLeave={() => setActiveMenu(null)}
                  >
                    {item.name}
                    <ChevronDownIcon className="h-4 w-4" />
                  </button>
                  <div 
                    className={`absolute left-0 top-full mt-1 bg-white shadow-lg rounded-md w-56 p-1 transition-all duration-200 ease-in-out ${activeMenu === item.name ? 'block' : 'hidden'}`}
                    onMouseEnter={() => setActiveMenu(item.name)}
                    onMouseLeave={() => setActiveMenu(null)}
                  >
                    {item.subMenu.map((subItem) => (
                      <Link 
                        key={subItem.name} 
                        to={subItem.href} 
                        className="block px-4 py-0 text-gray-700 hover:bg-[#5C4033] hover:text-white rounded-md"
                      >
                        {subItem.name}
                      </Link>
                    ))}
                  </div>
                </>
              ) : (
                <Link 
                  to={item.href} 
                  className="text-gray-700 hover:text-[#5C4033] px-3 py-2 border-b-2 border-transparent hover:border-[#391f13]"
                >
                  {item.name}
                </Link>
              )}
            </div>
          ))}
          
          {/* Login Button */}
          <Link 
            to="/login" 
            className="bg-[#5C4033] hover:bg-white text-white hover:text-[#5C4033] px-4 py-2 rounded-md transition-colors duration-200 border border-[#5C4033] ml-2"
          >
            Login
          </Link>
        </div>
        
        <button onClick={() => setMobileMenuOpen(true)} className="lg:hidden">
          <Bars3Icon className="h-6 w-6 text-gray-700" />
        </button>
      </nav>
      
      <Dialog open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} className="lg:hidden fixed inset-0 bg-white p-6 z-50">
        <button onClick={() => setMobileMenuOpen(false)} className="absolute top-4 right-4">
          <XMarkIcon className="h-6 w-6 text-gray-700" />
        </button>
        <div className="mt-6 text-center space-y-4">
          {navigation.map((item) => (
            <div key={item.name}>
              {item.subMenu ? (
                <>
                <button 
  className="w-full text-gray-700 font-semibold focus:outline-none flex items-center justify-between"
  onClick={() => setActiveMenu(activeMenu === item.name ? null : item.name)}
>
  <span className="mx-auto">{item.name}</span>
  <ChevronDownIcon className={`h-4 w-4 transform ${activeMenu === item.name ? 'rotate-180' : ''} transition-transform duration-200`} />
</button>

                  <div className={`pl-4 mt-2 space-y-2 ${activeMenu === item.name ? 'block' : 'hidden'}`}>
                    {item.subMenu.map((subItem) => (
                      <Link 
                        key={subItem.name} 
                        to={subItem.href} 
                        className="block text-gray-600 text-center hover:text-[#5C4033]"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        {subItem.name}
                      </Link>
                    ))}
                  </div>
                </>
              ) : (
                <Link 
                  to={item.href} 
                  className="block text-gray-700 font-semibold text-center hover:text-[#5C4033]"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              )}
            </div>
          ))}
          {/* Mobile Login Button */}
          <Link 
            to="/login" 
            className="block bg-[#5C4033] hover:bg-white text-white hover:text-[#5C4033] px-4 py-2 rounded-md text-center transition-colors duration-200 border border-[#5C4033] mt-4"
          >
            Login
          </Link>
        </div>
      </Dialog>
    </header>
  );
}


//do not change wnything else just see why services franchisees  and projects in the mobile header options are not looking center align